<template>
    <div id="comps">
        <h1 class="title">Реестр радиоэлектронных компонентов</h1>
        <button style="margin: 1.5% 0% 0% 0%;" @click="showNewRecord = true" class="btn btn-outline-primary">Создать
            запись</button>
        <div style="margin-top: 2%; width: 40%" class="input-group mb-3">
            <div class="input-group">
                <div id="validationServerUsernameFeedback" class="invalid-feedback">
                    Заполните поле
                </div>
                <input @keyup.enter="searchComp" @click="invalid = []" ref="Sdata" type="text"
                    :class="'form-control ' + (!!~invalid.indexOf('search') ? 'is-invalid' : '')"
                    placeholder="Введите название, номинал, или место хранения" aria-describedby="basic-addon1">
                <button @click="searchComp" class="btn btn-outline-secondary" id="basic-addon1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-search" viewBox="0 0 16 16">
                        <path
                            d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0">
                        </path>
                    </svg>
                </button>
            </div>
        </div>

        <div v-if="showResults" id="compRes">
            <a v-for="(comp, n) in results" @click="showCompId = comp[0]; showComp()" :key="comp[0]" href="#">
                <h4>{{ n + 1 }}. {{ comp[1] }} {{ comp[2] }} - {{ comp[4] }} шт. ({{ comp[3] }})</h4>
            </a>

            <div v-if="results.length == 0">
                <h4 style="color: #00000093;">Результаты не найдены</h4>
            </div>
        </div>

        <div v-if="showCompId > -1" id="comp" class="input-group mb-3">
            <div class="d-grid gap-2 d-md-block">
                <button id="takebtn" @click="showTake = true" role="button" aria-pressed="true" href="#" type="button"
                    class="btn btn-outline-primary">
                    Взять
                </button>
                <button id="addbtn" @click="showAdd = true" role="button" aria-pressed="true" href="#" type="button"
                    class="btn btn-outline-primary">
                    Пополнить
                </button>
                <div id="validationServerLinkFeedback" class="valid-feedback">
                    Изменения сохранены!
                </div>
            </div>
            <div style="margin-top: 2%">
                <h4><u>Вид элемента:</u> {{ one_comp[0] }}</h4>
                <h4><u>Описание, параметры:</u> {{ one_comp[1] }}</h4>
                <h4><u>Место хранения, ячейка:</u> {{ one_comp[2] }}</h4>
                <h4><u>Количество:</u> {{ one_comp[3] }}</h4>
                <h4><u>Последнее изменение:</u> {{ lastRecord }}</h4>
            </div>
        </div>

        <div v-if="showNewRecord" class="modal fade show" tabindex="-1" aria-labelledby="exampleModalLabel"
            aria-modal="true" role="dialog" style="display:block">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Создать новую запись</h5>
                        <button @click="showNewRecord = false; invalid = []; newAdded = false" type="button"
                            class="btn-close" data-bs-dismiss="modal" aria-label="Закрыть"></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="this.error" class="alert alert-danger" role="alert">
                            {{ msg }}
                        </div>
                        <div class="alert alert-warning" role="alert">Убедительная просьба, внимательно заполняйте все
                            пункты данной формы! От этого зависит
                            скорость поиска компонента в дальнейшем Вами и Вашими коллегами!</div>
                        <hr class="hr" />
                        <div v-if="this.newAdded" class="alert alert-success" role="alert">
                            Данные успешно сохранены!
                        </div>
                        <div class="mb-3">
                            <label for="name" class="form-label">Вид элемента:</label>
                            <input type="text"
                                :class="'form-control ' + (!!~invalid.indexOf('name') ? 'is-invalid' : '')" id="name"
                                ref="name" placeholder="Вид элемента" aria-label="Вид элемента"
                                aria-describedby="basic-addon1">
                            <div id="validationServerUsernameFeedback" class="invalid-feedback">
                                Заполните поле
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="name" class="form-label">Маркировка, параметры элемента, паспорт и т.д.:</label>
                            <input type="text"
                                :class="'form-control ' + (!!~invalid.indexOf('value') ? 'is-invalid' : '')" id="value"
                                ref="value" placeholder="Описание" aria-label="Описание"
                                aria-describedby="basic-addon1">
                            <div id="validationServerUsernameFeedback" class="invalid-feedback">
                                Заполните поле
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="name" class="form-label">Номер ячейки хранения, место:</label>
                            <input type="text"
                                :class="'form-control ' + (!!~invalid.indexOf('place') ? 'is-invalid' : '')" id="place"
                                ref="place" placeholder="Место хранения" aria-label="Место хранения"
                                aria-describedby="basic-addon1">
                            <div id="validationServerUsernameFeedback" class="invalid-feedback">
                                Заполните поле
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="name" class="form-label">Количество (число шт.):</label>
                            <input type="text"
                                :class="'form-control ' + (!!~invalid.indexOf('quantity') ? 'is-invalid' : '')"
                                id="quantity" ref="quantity" placeholder="Количество" aria-label="Количество"
                                aria-describedby="basic-addon1">
                            <div id="validationServerUsernameFeedback" class="invalid-feedback">
                                Заполните поле
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="createNewRecord" type="submit" class="btn btn-primary"
                            id="nd_sub">Создать</button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showTake" class="modal fade show" tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true"
            role="dialog" style="display:block">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Взять элемент</h5>
                        <button @click="showTake = false; invalid = []; newAdded = false" type="button"
                            class="btn-close" data-bs-dismiss="modal" aria-label="Закрыть"></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="this.newAdded" class="alert alert-success" role="alert">
                            Данные успешно сохранены!
                        </div>
                        <div class="mb-3">
                            <label for="quantity" class="form-label">Количество:</label>
                            <input @keyup.enter="take" type="text"
                                :class="'form-control ' + (!!~invalid.indexOf('quantity') ? 'is-invalid' : '')"
                                id="quantity" ref="quantity_take" :placeholder="'Не более ' + one_comp[3] + ' шт.'"
                                aria-label="Количество" aria-describedby="basic-addon1">
                            <div id="validationServerUsernameFeedback" class="invalid-feedback">
                                Укажите правильную величину
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="take" type="submit" class="btn btn-primary" id="nd_sub">Взять</button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showAdd" class="modal fade show" tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true"
            role="dialog" style="display:block">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Пополнить элемент</h5>
                        <button @click="showAdd = false; invalid = []; newAdded = false" type="button" class="btn-close"
                            data-bs-dismiss="modal" aria-label="Закрыть"></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="this.newAdded" class="alert alert-success" role="alert">
                            Данные успешно сохранены!
                        </div>
                        <div class="mb-3">
                            <label for="quantity" class="form-label">Количество:</label>
                            <input @keyup.enter="add" type="text"
                                :class="'form-control ' + (!!~invalid.indexOf('quantity') ? 'is-invalid' : '')"
                                id="quantity" ref="quantity_add" placeholder="Количество" aria-label="Количество"
                                aria-describedby="basic-addon1">
                            <div id="validationServerUsernameFeedback" class="invalid-feedback">
                                Укажите правильную величину
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="add" type="submit" class="btn btn-primary" id="nd_sub">Пополнить</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RadioComps",
    data() {
        return {
            showNewRecord: false,
            showTake: false,
            showAdd: false,
            newAdded: false,
            showResults: false,
            showCompId: -1,
            error: false,
            msg: '',
            lastRecord: '',
            one_comp: [],
            results: [],
            invalid: []
        }
    },
    methods: {
        showComp() {
            fetch("https://api.bormart.ru/comp_journal?comp_id=" + this.showCompId, {
                method: "GET",
                credentials: "include",
                headers: {
                    "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
                    "Cookie": document.cookie
                }
            }).then((response) => {
                return response.json()
            }).then((data) => {
                if (data["ok"] == 1) {
                    this.lastRecord = data['record']
                    this.one_comp = data['comp']
                }
            })
        },
        add() {
            this.invalid = []
            const quantity = this.$refs.quantity_add.value
            if (quantity.length == 0 || isNaN(Number(quantity))) {
                this.invalid.push("quantity")
                return
            }
            fetch("https://api.bormart.ru/add_comp", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "Cookie": document.cookie
                },
                body: JSON.stringify({
                    "comp_id": this.showCompId,
                    "quantity": quantity
                })
            }).then((response) => {
                return response.json()
            }).then((data) => {
                if (data["ok"] == 1) {
                    this.newAdded = true
                    this.searchComp()
                    this.showComp()
                }
            })
        },
        take() {
            this.invalid = []
            const quantity = this.$refs.quantity_take.value
            if (quantity.length == 0 || (Number(quantity) > Number(this.one_comp[3])) || isNaN(Number(quantity))) {
                this.invalid.push("quantity")
                return
            }
            fetch("https://api.bormart.ru/take_comp", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "Cookie": document.cookie
                },
                body: JSON.stringify({
                    "comp_id": this.showCompId,
                    "quantity": quantity
                })
            }).then((response) => {
                return response.json()
            }).then((data) => {
                if (data["ok"] == 1) {
                    this.newAdded = true
                    this.searchComp()
                    this.showComp()
                }
            })
        },
        createNewRecord() {
            this.error = false
            this.msg = ''
            this.invalid = []
            const name = this.$refs.name.value
            const value = this.$refs.value.value
            const place = this.$refs.place.value
            const quantity = this.$refs.quantity.value
            if (name.length == 0) {
                this.invalid.push("name")
                return
            }
            if (value.length == 0) {
                this.invalid.push("value")
                return
            }
            if (place.length == 0) {
                this.invalid.push("place")
                return
            }
            if (quantity.length == 0 || isNaN(Number(quantity))) {
                this.invalid.push("quantity")
                return
            }
            fetch("https://api.bormart.ru/new_comp", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "Cookie": document.cookie
                },
                body: JSON.stringify({
                    "name": name,
                    "value": value,
                    "place": place,
                    "quantity": quantity
                })
            }).then((response) => {
                return response.json()
            }).then((data) => {
                if (data["ok"] == 1) {
                    this.newAdded = true
                } else if (data['ok'] == 0) {
                    this.error = true
                    switch (data['cause']) {
                        case 'Comp already exists':
                            this.msg = "Такой компонент уже имеется в базе!"
                            break;
                    }
                }
            })
        },
        searchComp(inp_data) {
            var data = ''
            if (inp_data != "auto") {
                this.invalid = []
                data = this.$refs.Sdata.value
                if (data.length == 0) {
                    this.invalid.push("search")
                    return
                }
            } else {
                data = " "
            }

            fetch("https://api.bormart.ru/search_comps", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "Cookie": document.cookie
                },
                body: JSON.stringify({
                    "data": data
                })
            }).then((response) => {
                return response.json()
            }).then((data) => {
                if (data["ok"] == 1) {
                    this.results = data['comps']
                    this.showResults = true
                }
            })
        }
    },
    mounted() {
        this.searchComp("auto")
    }
}
</script>